import { TableRes } from '../global'
import request from '../tools/request'
import { HTTP } from './http'

const { GET } = request

// 联系人数据类型定义
export interface ContactPageData {
  id: string
  name: string
  sex: string
  duty: string
  mail: string
  phone: string
  area: string
  contactAddress?: string
}

// 联系人分页查询参数
export interface ContactPageParams {
  supplierId: string
  groupCode: string
  name?: string
  pageNo?: number
  pageSize?: number
}

/**
 * 根据供应商id和组织code分页查询联系人列表
 * @param params 查询参数
 * @returns 联系人分页数据
 */
export const GET_CONTACT_LIST_BY_SUPPLIER_AND_GROUP = (params: ContactPageParams) =>
  GET<TableRes<ContactPageData>>(`${HTTP}/contact/getContactListBySupplierIdAndGroupCode`, params)import { TableRes } from '../global'
import request from '../tools/request'
import { HTTP } from './http'

const { GET } = request

// 联系人数据类型定义
export interface ContactPageData {
  id: string
  name: string
  sex: string
  duty: string
  mail: string
  phone: string
  area: string
  contactAddress?: string
}

// 联系人分页查询参数
export interface ContactPageParams {
  supplierId: string
  groupCode: string
  name?: string
  pageNo?: number
  pageSize?: number
}

/**
 * 根据供应商id和组织code分页查询联系人列表
 * @param params 查询参数
 * @returns 联系人分页数据
 */
export const GET_CONTACT_LIST_BY_SUPPLIER_AND_GROUP = (params: ContactPageParams) =>
  GET<TableRes<ContactPageData>>(`${HTTP}/contact/getContactListBySupplierIdAndGroupCode`, params)